module.exports = __webpack_public_path__ + "4dd7ccfd03c775708627d742d46972ce.pdf";